import { styled } from '@mui/material/styles';
import { compose } from 'utils/compose';
import { observer, inject } from 'mobx-react';
const PREFIX = 'SessionTime';

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: '2rem',
    color: theme.palette.primary.main,
  },
}));

export const SessionTime = compose(
  inject('store'),
  observer,
)(({ store }) => {
  const { deliveryStore } = store;
  const { delivery, tokenRemainingTimeString } = deliveryStore;

  if (!delivery) return null;

  return (
    <Root className={classes.root}>
      <span>Session time: </span>
      <span>{tokenRemainingTimeString}</span>
    </Root>
  );
});
